import { FC, ReactElement } from "react";
import { Avatar as MuiAvatar } from "@mui/material";

interface Props {
  url?: string;
  width: number;
  height: number;
}

const Avatar: FC<Props> = ({ url, width, height }): ReactElement => {
  return (
    <MuiAvatar
      sx={{
        width,
        height,
      }}
      src={url}
    />
  );
};

export default Avatar;
